import { FC } from 'react';

import { Field, Fieldset, Combobox } from '@/components';

import { CreateProjectFormData } from '../types';

interface ServicesFieldsProps {
  formData: CreateProjectFormData;
  errors: Partial<Record<keyof CreateProjectFormData, string>>;
  onFieldChange: (field: keyof CreateProjectFormData, value: unknown) => void;
  servicesOptions: Array<{ label: string; value: string }>;
}

export const ServicesFields: FC<ServicesFieldsProps> = ({
  formData,
  errors,
  onFieldChange,
  servicesOptions,
}) => {
  return (
    <Fieldset legend="Services Override (Superuser Only)">
      <Field
        label="Additional Services"
        htmlFor="services-override-select"
        error={errors.availableServicesOverride}
      >
        <Combobox
          optionGroups={[
            {
              label: 'Services',
              options: servicesOptions.map((option) => ({
                label: option.label,
                value: option.value,
              })),
            },
          ]}
          value={formData.availableServicesOverride}
          onValueChange={(values) => {
            onFieldChange('availableServicesOverride', values);
          }}
          fallbackLabel={'no services found'}
          placeholder={'Select additional services for this project'}
          fullWidth
        />
      </Field>
      <p className="text-sm text-muted-foreground mt-2">
        These services will be added to this project in addition to the organization&apos;s
        available services.
      </p>
    </Fieldset>
  );
};
